import { ITabStorage } from './tab-data-storage';
import { TabName } from 'src/app/infrastructure/services/page-services/models/tab-name';
import { TPageMode } from 'src/app/infrastructure/models/page-mode';

export const tabPageStorage = {
    tabName: 'tabName',
    lists: 'lists',
    tabMode: 'tabMode',
    tabHeight: 'tabHeight',
} as const;

export type TTabPageStorage = (typeof tabPageStorage)[keyof typeof tabPageStorage];

export interface ITabPageStorage {
    [tabPageStorage.tabName]: TabName | null;
    [tabPageStorage.lists]: Record<string, ITabStorage>;
    [tabPageStorage.tabMode]: TPageMode | null;
    [tabPageStorage.tabHeight]: number | null;
}

export class TabPageStorage
    implements ITabPageStorage
{
    [tabPageStorage.tabName]: TabName | null = null;
    [tabPageStorage.lists]: Record<string, ITabStorage> = {};
    [tabPageStorage.tabMode]: TPageMode | null = null;
    [tabPageStorage.tabHeight]: number | null = null;

    constructor();
    constructor(data: ITabPageStorage);
    constructor(data?: ITabPageStorage) {
        if (!data) return;

        this[tabPageStorage.tabName] = data[tabPageStorage.tabName] ?? null;
        this[tabPageStorage.lists] = data[tabPageStorage.lists] ?? {};
        this[tabPageStorage.tabMode] = data[tabPageStorage.tabMode] ?? null;
        this[tabPageStorage.tabHeight] = data[tabPageStorage.tabHeight] ?? null;
    }
}
